// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"compoundComponent_wrapper__175sz","title":"compoundComponent_title__20DOo","label":"compoundComponent_label__2sJ_2"};